import React from 'react';
import { Card, CardHeader, CardContent } from '../ui/card';
import { FormGroup, FormLabel, FormInput } from '../ui/form';
import { Badge } from '../ui/badge';
import { 
  User, 
  Mail, 
  Calendar, 
  Save, 
  X,
  CheckCircle
} from 'lucide-react';

const ProfileForm = ({ 
  profile, 
  editing, 
  firstName, 
  setFirstName,
  lastName, 
  setLastName,
  username, 
  setUsername,
  updateProfile,
  setEditing 
}) => {
  return (
    <Card>
      <CardHeader>
        <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100 flex items-center gap-2">
          <User className="w-5 h-5" />
          Profile Information
        </h2>
      </CardHeader>
      <CardContent>
        {!editing ? (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-4">
              <div>
                <label className="text-sm font-medium text-gray-500 dark:text-gray-400">First Name</label>
                <p className="mt-1 text-gray-900 dark:text-gray-100 font-medium">
                  {profile?.first_name || 'Not set'}
                </p>
              </div>
              <div>
                <label className="text-sm font-medium text-gray-500 dark:text-gray-400">Last Name</label>
                <p className="mt-1 text-gray-900 dark:text-gray-100 font-medium">
                  {profile?.last_name || 'Not set'}
                </p>
              </div>
              <div>
                <label className="text-sm font-medium text-gray-500 dark:text-gray-400">Username</label>
                <p className="mt-1 text-gray-900 dark:text-gray-100 font-medium">
                  {profile?.username || 'Not set'}
                </p>
              </div>
            </div>
            <div className="space-y-4">
              <div>
                <label className="text-sm font-medium text-gray-500 dark:text-gray-400">Email Address</label>
                <p className="mt-1 text-gray-900 dark:text-gray-100 font-medium flex items-center gap-2">
                  <Mail className="w-4 h-4" />
                  {profile?.email}
                </p>
              </div>
              <div>
                <label className="text-sm font-medium text-gray-500 dark:text-gray-400">Member Since</label>
                <p className="mt-1 text-gray-900 dark:text-gray-100 font-medium flex items-center gap-2">
                  <Calendar className="w-4 h-4" />
                  {new Date(profile?.created_at).toLocaleDateString('en-US', { 
                    year: 'numeric', 
                    month: 'long', 
                    day: 'numeric' 
                  })}
                </p>
              </div>
              <div>
                <label className="text-sm font-medium text-gray-500 dark:text-gray-400">Account Status</label>
                <div className="mt-1">
                  <Badge variant="success" className="flex items-center gap-1 w-fit">
                    <CheckCircle className="w-3 h-3" />
                    Active
                  </Badge>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <form onSubmit={updateProfile} className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <FormGroup>
                <FormLabel htmlFor="firstName">First Name</FormLabel>
                <FormInput
                  id="firstName"
                  type="text"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  placeholder="Enter your first name"
                />
              </FormGroup>
              <FormGroup>
                <FormLabel htmlFor="lastName">Last Name</FormLabel>
                <FormInput
                  id="lastName"
                  type="text"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  placeholder="Enter your last name"
                />
              </FormGroup>
            </div>
            <FormGroup>
              <FormLabel htmlFor="username">Username</FormLabel>
              <FormInput
                id="username"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Enter your username"
              />
            </FormGroup>
            <FormGroup>
              <FormLabel htmlFor="email">Email Address</FormLabel>
              <FormInput
                id="email"
                type="email"
                value={profile?.email}
                disabled
                readOnly
              />
              <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
                Email cannot be changed here. Contact support if needed.
              </p>
            </FormGroup>
            <div className="flex gap-3 pt-4">
              <button
                type="submit"
                className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
              >
                <Save className="w-4 h-4" />
                Save Changes
              </button>
              <button
                type="button"
                onClick={() => setEditing(false)}
                className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
              >
                <X className="w-4 h-4" />
                Cancel
              </button>
            </div>
          </form>
        )}
      </CardContent>
    </Card>
  );
};

export default ProfileForm;
